let cache = null;

const toBase64 = (buf) => {
  const bytes = new Uint8Array(buf);
  let bin = "";
  for (let i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  return btoa(bin);
};

const loadFonts = async () => {
  if (cache) return cache;
  const [regular, bold] = await Promise.all(
    ["Roboto-Regular.ttf", "Roboto-Bold.ttf"].map((f) => fetch(`/fonts/${f}`).then((r) => {
      if (!r.ok) throw new Error(`Font yüklenemedi: ${f}`);
      return r.arrayBuffer();
    }).then(toBase64))
  );
  cache = { regular, bold };
  return cache;
};

// Registers embedded Unicode font (Turkish ğşıİ safe) on a jsPDF instance, returns font name
export const registerPdfFont = async (pdf) => {
  const { regular, bold } = await loadFonts();
  pdf.addFileToVFS("Roboto-Regular.ttf", regular);
  pdf.addFont("Roboto-Regular.ttf", "Roboto", "normal");
  pdf.addFileToVFS("Roboto-Bold.ttf", bold);
  pdf.addFont("Roboto-Bold.ttf", "Roboto", "bold");
  return "Roboto";
};
